import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type ExtendedWarrantyState = Record<string, never>;

export const EXTENDED_WARRANTY = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ExtendedWarrantyState>
  >,
): ConditionType<ExtendedWarrantyState, Condition.ExtendedWarranty> => ({
  name: "Extended warranty is live on item",
  description() {
    return "Extended warranty is live on item";
  },
  Details(props: ConditionTypeDetailsProps<ExtendedWarrantyState>) {
    return React.createElement(Details, props);
  },
  empty: {},
  fromModel(model) {
    return {};
  },
  toModel(state) {
    return { type: Condition.EXTENDED_WARRANTY };
  },
  valid(state) {
    return true;
  },
});
